import { render } from "./SquareComponent.vue?vue&type=template&id=64eb12fc&scoped=true"
import script from "./SquareComponent.vue?vue&type=script&lang=js"
export * from "./SquareComponent.vue?vue&type=script&lang=js"

import "./SquareComponent.vue?vue&type=style&index=0&id=64eb12fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eb12fc"]])

export default __exports__